// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JTRpZE6uPAYovicLETYk{color:var(--content-negative-primary)}.pIailWwHGxUv9717e1_4{align-items:center;height:100%;display:flex}._PkZ3HRSJZIB0RKBTg7K{color:var(--content-primary-primary);font-size:13px;font-weight:400;line-height:normal}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"warning": `JTRpZE6uPAYovicLETYk`,
	"countLabelWrapper": `pIailWwHGxUv9717e1_4`,
	"countLabel": `_PkZ3HRSJZIB0RKBTg7K`
};
export default ___CSS_LOADER_EXPORT___;
